import { CommitmentsStats } from "features/commitments/CommitmentsStats";
import { CommitmentsTable } from "features/commitments/CommitmentsTable";
import { CommitmentsTabProps } from "features/commitments/tabs/CommitmentsTabProps";
import React from "react";
import { useOutletContext } from "react-router-dom";
import { PageTabBody } from "shared/components/layout/PageTabBody";

export const CommitmentsTabCommitments: React.FC = () => {
  const { fundFamilyId } = useOutletContext<CommitmentsTabProps>();
  return (
    <PageTabBody>
      <CommitmentsStats fundFamilyId={fundFamilyId} />
      <CommitmentsTable fundFamilyId={fundFamilyId} isFullWidth={true} />
    </PageTabBody>
  );
};
